export function ToContactList(_contactList: any) {
  const contactList = [];
  if (_contactList !== null) {
    for (let i = 0; i < _contactList.length; i++) {
      const contactData = {
        id: _contactList[i].id,
        contactBranchCode: _contactList[i].contactBranchCode,
        contactTaxId: _contactList[i].contactTaxId,
        contactCode: _contactList[i].contactCode,
        contactFullName: _contactList[i].contactFullName,
        contactFullNameEng: _contactList[i].contactFullNameEng,
        contactFullNameTh: _contactList[i].contactFullNameTh,
        contactShortName: _contactList[i].contactShortName,
        contactShortNameEng: _contactList[i].contactShortNameEng,
        contactShortNameTh: _contactList[i].contactShortNameTh,
        contactName: _contactList[i].contactName,
        contactType: _contactList[i].contactType,
        incomeDueDateTypeId: _contactList[i].incomeDueDateTypeId,
        incomeDueDateDay: _contactList[i].incomeDueDateDay,
        outflowDueDateTypeId: _contactList[i].outflowDueDateTypeId,
        outflowDueDateDay: _contactList[i].outflowDueDateDay,
        address: _contactList[i].address,
        phoneNumber: _contactList[i].contactPhoneNumber,
        email: _contactList[i].contactEmail,
        webSite: _contactList[i].contactWebSite,
        personFirstName: _contactList[i].personFirstName,
        personLastName: _contactList[i].personLastName,
        personNickName: _contactList[i].personNickName,
        personEmail: _contactList[i].personEmail,
        personPhone: _contactList[i].personPhone,
        contactWhtType: _contactList[i].contactWhtType,
        status: "null",
        logoUrl: _contactList[i].logoUrl,
        accountsPayableAccountId: _contactList[i].accountsPayableAccountId,
        accountsReceivableAccountId: _contactList[i].accountsReceivableAccountId,
        isDeleted: _contactList[i].isDeleted,
        isArchived: _contactList[i].isArchived,
        isFavorite: false,
        sortNumber: 0,
        isSuggest: false,
      };
      contactList.push(contactData);
    }
  }
  return contactList;
}
